import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { PageHeader } from '@/components/layouts/PageHeader';
import { ClientIcon } from '@/components/icons/Client';
import { paths } from '@/app/paths';
import { useAdminModeAccess } from '@/hooks/useAdminModeAccess';

const pageIcons = {
	Users: <GroupOutlinedIcon />,
	Networks: <HubOutlinedIcon />,
	Brokers: <BusinessOutlinedIcon />,
	Clients: <ClientIcon width='40px' height='40px' bgColor='transparent' />,
	'Feature Flags': <FlagOutlinedIcon />,
};

export const AdminRoute = () => {
	const { canAccessAdminMode, isAdminModeAccessLoading } = useAdminModeAccess();

	if (isAdminModeAccessLoading) {
		return (
			<AuthenticatedPageLayout>
				<Box display='flex' justifyContent='center' pt='4em'>
					<CircularProgress />
				</Box>
			</AuthenticatedPageLayout>
		);
	}

	if (!canAccessAdminMode) {
		return <Navigate to={paths.home} replace />;
	}

	return <Outlet />;
};

export const AdminPage = ({ title, children }) => {
	return (
		<AuthenticatedPageLayout>
			<PageHeader title={title} icon={pageIcons[title]} />
			{children && <Box sx={{ px: 3, pb: 3 }}>{children}</Box>}
		</AuthenticatedPageLayout>
	);
};
